import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getDefaultRoute } from '../../helpers';

function RedirectIfLoggedInRoute() {
    const defaultRoute = getDefaultRoute();
    return defaultRoute ? <Navigate replace to={defaultRoute} /> : <Outlet />;
}

export default RedirectIfLoggedInRoute;
